export const mapBoxAPIKey = import.meta.env.VITE_APP_MAPBOX_API_KEY
